/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Vam_Friendly_NameInputs */

const en_exp_vam_friendly_name = /** @type {(inputs: Exp_Vam_Friendly_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VAM`)
};

const de_exp_vam_friendly_name = /** @type {(inputs: Exp_Vam_Friendly_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VAM`)
};

/**
* | output |
* | --- |
* | "VAM" |
*
* @param {Exp_Vam_Friendly_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_vam_friendly_name = /** @type {((inputs?: Exp_Vam_Friendly_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Vam_Friendly_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_vam_friendly_name(inputs)
	return de_exp_vam_friendly_name(inputs)
});